import type { TableDataDto } from 'cadenza/ui/base-table/model/table-data-dto';
import { ajax } from 'cadenza/api-client/api';
import { PARAMETER_CONDITION_HASH } from 'cadenza/api-client/api-constants';
import { MIMETYPE_JSON } from 'cadenza/model/media-type';
import { getCurrentHierarchyParameters } from 'cadenza/api-client/processing-param-util';

interface ProcessingChainUrlDto {
  url: string;
}

/* @see net/disy/services/selector/api/rest/base/SelectorEndpointController.java */
export function drillThrough (drillThroughTargetId: string, rowsData: TableDataDto, warningsAccepted = false) {
  if (drillThroughTargetId == null) {
    throw new Error('DrillThrough API error: drillThroughTargetId must be set.');
  }

  const currentSearchParams = new URLSearchParams(window.location.search);
  const selector = currentSearchParams.get('selector');

  const destinationSearchParams = new URLSearchParams();
  destinationSearchParams.set(PARAMETER_CONDITION_HASH, String(currentSearchParams.get(PARAMETER_CONDITION_HASH)));
  destinationSearchParams.set('drillThroughTarget', drillThroughTargetId);
  destinationSearchParams.set('warningsAccepted', String(warningsAccepted));
  destinationSearchParams.set('selector', String(selector));
  if (currentSearchParams.has('columns')) {
    destinationSearchParams.set('columns', String(currentSearchParams.get('columns')));
  }
  if (currentSearchParams.has('processings')) {
    destinationSearchParams.set('processings', String(currentSearchParams.getAll('processings')));
  }
  const hierarchyParams = getCurrentHierarchyParameters();
  for (const property in hierarchyParams) {
    destinationSearchParams.set(property, String(hierarchyParams.get(property)));
  }

  const destSearchParam = destinationSearchParams.toString();

  return ajax<ProcessingChainUrlDto>(`/selectors?${destSearchParam}`, {
    type: 'POST',
    contentType: MIMETYPE_JSON,
    dataType: 'json',
    data: JSON.stringify({ rows: rowsData }),
    traditional: true
  });
}
